// Options with default values
import localForage from "localforage";
localForage.config({
  //driver      : localforage.WEBSQL, // Force WebSQL; same as using setDriver()
  name        : "ArchPMS",
  version     : 1.0,
  size        : 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName   : "ArchPMS_Storage", // Should be alphanumeric, with underscores.
  description : "ArchPMS Local Storage"
});
export default localForage;
